import { StopOutlined } from '@ant-design/icons';
import DiscussionPanel from '@/components/module/projects/discussion/DiscussionPanel';
import SidePanel from '@/components/ui/SidePanel';
import { StatusBadge } from '@/components/ui/StatusBadge';
import { useBlockerDiscussions } from '@hooks/projects/discussion/useBlockerDiscussions';
import { getBlockerDisplayName } from '@hooks/projects/projectHelpers';

/**
 * Projects module: side-panel for blocker discussions.
 * Used by QATaskDetailModal and SprintTaskDetailModal.
 */
export default function BlockerDiscussionSidePanel({ projectId, taskId, blocker, mentionUsers = [], onClose }) {
    const open = Boolean(projectId && blocker?.id);
    const blockerId = blocker?.id ?? '';

    const {
        discussions,
        isLoading,
        createPost,
        createPostPending,
        editPost,
        editPostPending,
        deletePost,
        deletePostPending,
    } = useBlockerDiscussions(
        open ? projectId : null,
        open ? blockerId : null,
        taskId,
    );

    const blockerLabel = blocker ? getBlockerDisplayName(blocker) || '' : '';
    const title = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <StopOutlined />
                <span>Blocker Discussion</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, fontWeight: 500, opacity: 0.9 }}>
                {blockerLabel ? <span>{blockerLabel}</span> : null}
                {blocker?.status ? <StatusBadge status={blocker.status} size="small" style={{ flexShrink: 0 }} /> : null}
            </div>
        </div>
    );

    const PANEL_Z_INDEX = 1200;

    return (
        <SidePanel
            open={open}
            title={title}
            width="45%"
            // Above AppModal (1100). DiscussionPanel will raise its popups/modals above this.
            zIndex={PANEL_Z_INDEX}
            bodyPadding="0"
            bodyOverflowY="hidden"
            closeOnOverlayClick={false}
            onClose={onClose}
        >
            {open && (
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%', overflow: 'hidden' }}>
                    <DiscussionPanel
                        variant="chat"
                        showHeader={false}
                        zIndexBase={PANEL_Z_INDEX}
                        projectId={projectId}
                        mentionUsers={mentionUsers}
                        discussions={discussions}
                        isLoading={isLoading}
                        createPost={createPost}
                        createPostPending={createPostPending}
                        editPost={editPost}
                        editPostPending={editPostPending}
                        deletePost={deletePost}
                        deletePostPending={deletePostPending}
                        sectionLabel="Discussion"
                        emptyIcon={<StopOutlined />}
                        emptyTitle="No discussion yet"
                        emptyDesc="Add a comment below."
                    />
                </div>
            )}
        </SidePanel>
    );
}

